/* eslint-disable global-require */
export const CommonImages = {
  logoBird: require('./img/logoBird.png'),
  dexcomLogo: require('./img/dexcomLogo.png'),
  mindspanIcon: require('./img/mindspanIcon.png'),
};
